module.exports = __webpack_public_path__ + "ptc_momoro_U2.b972cbbc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/momoro/parent_to_child/ptc_momoro_U2.jpg
// module id = zLsy
// module chunks = 0